import { useTranslations } from "use-intl";
import Text from "@/shared/typography/text";

export function ChangingAttributeTypeHint() {
  const t = useTranslations("AttributeFormView");

  return (
    <Text type="caption" color="secondary">
      {t(
        "When changing the attribute type, all values of this attribute will be lost",
      )}
    </Text>
  );
}

export function ChangingAttributeCodeHint() {
  const t = useTranslations("AttributeFormView");

  return (
    <Text type="caption" color="secondary">
      {t(
        "When changing the attribute code, all values of this attribute will be lost",
      )}
    </Text>
  );
}
